import { MenuRoute } from "../../components/menu";
import { PageNotFoundPage } from "./not-found";

const names = {
  pageNotFound: `page-not-found`,
};

const states: MenuRoute[] = [
  {
    name: names.pageNotFound,
    component: PageNotFoundPage,
    data: {
      title: "page-not-found",
    },
  },
];

export const PageNotFoundRoutes = {
  names,
  states,
};
